import React from 'react';

/**
 * Componente de loading spinner
 */
const LoadingSpinner = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
        <p className="text-gray-600">Processando dados...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
